import script from "./adv-textbox.vue?vue&type=script&setup=true&lang=js"
export * from "./adv-textbox.vue?vue&type=script&setup=true&lang=js"

import "./adv-textbox.vue?vue&type=style&index=0&id=628eb985&lang=scss"

const __exports__ = script;

export default __exports__